import { useLang } from "@/context/LanguageContext";
import { Kicker } from "@/components/Section";
import { BookOpenCheck } from "lucide-react";

export default function Regelkurs() {
  const { lang, t: cms } = useLang();
  const t = (de, en) => (lang === "de" ? de : en);
  const r = cms.regelkurs || {};
  return (
    <div data-testid="regelkurs-page">
      <section className="pt-36 md:pt-44 pb-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Kicker>{r.kicker || t("// REGELKURS · PLATZREIFE", "// RULES COURSE · COURSE PERMIT")}</Kicker>
        <h1 className="font-heading text-5xl sm:text-6xl md:text-8xl uppercase tracking-tight leading-none text-white mt-4 fade-up">
          {r.title || t("Regelkurs", "Rules course")}
        </h1>
        <p className="text-neutral-400 text-base md:text-lg max-w-2xl mt-6">
          {r.intro || t("Absolviere hier Deine Regel-Tests und bestehe den Regelteil der Platzreife – online, in Deinem Tempo. Arbeite die Lektionen durch und schließe am Ende den Regeltest ab.",
             "Complete your rules tests here and pass the rules part of the course permit – online, at your own pace. Work through the lessons and finish with the rules test.")}
        </p>
        <div className="mt-4 flex items-center gap-2 text-neutral-500 text-sm">
          <BookOpenCheck size={16} className="text-[#ff0033]" />
          <span>{r.note || t("Bereitgestellt über Golftimer · Fortschritt wird im Regelsystem gespeichert", "Provided via Golftimer · progress is saved in the rules system")}</span>
        </div>
      </section>

      <section className="pb-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border border-white/10 bg-white" data-testid="regelkurs-iframe-wrap">
          <iframe
            src="https://ssl.golftimer.de/RegelStart.php?RegSys=A82"
            title={t("Regelkurs Platzreife", "Rules course")}
            frameBorder="0"
            width="100%"
            height="3000"
            onLoad={() => window.scrollTo(0, 0)}
            data-testid="regelkurs-iframe"
          />
        </div>
      </section>
    </div>
  );
}
